import React from 'react';
export function Terms() {
  return <div className="pt-20" data-id="element-1644">
      {/* Hero */}
      <section className="pt-10 pb-6 md:pt-16 md:pb-8 bg-gradient-to-br from-gray-50 to-white" data-id="element-1645">
        <div className="container-custom" data-id="element-1646">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1647">
            <h1 className="mb-4" data-id="element-1648">HIRE Advantage Agreement</h1>
            <p className="text-body-large text-gray-600" data-id="element-1649">
              Terms and Conditions of Service
            </p>
          </div>
        </div>
      </section>

      {/* Agreement Content */}
      <section className="py-8 md:py-12 bg-white" data-id="element-1650">
        <div className="container-custom" data-id="element-1651">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1652">
            {/* Preamble */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-1653">
              <p className="leading-relaxed" data-id="element-1654">
                This HIRE Advantage Agreement (together with all applicable
                Services Order(s) and addenda, executed hereunder, the
                "Agreement") is entered into by and between the HIRE entity
                identified in a Service Order ("HIRE") and the counterparty to
                that Service Order ("Client") and contains the terms and
                conditions that govern Client's access to and use of the Scope
                of Services (see defined below). This agreement is effective
                when Client executes a Services Order referencing this Agreement
                (the "Effective Date").
              </p>
            </div>

            {/* 1. Introduction & Recitals */}
            <div className="mb-12" data-id="element-1655">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1656">
                1. Introduction & Recitals
              </h2>
              <p className="leading-relaxed" data-id="element-1657">
                HIRE provides high-performance recruiting solutions designed to
                scale businesses. Under this Agreement, HIRE will deliver its
                Proprietary Recruiting System, which combines advanced
                recruiting services with consulting, coaching, and ongoing
                support to optimize candidate experience, onboarding, and
                retention.
              </p>
            </div>

            {/* 2. Definitions */}
            <div className="mb-12" data-id="element-1658">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1659">
                2. Definitions
              </h2>

              <div className="space-y-4" data-id="element-1660">
                <p className="leading-relaxed" data-id="element-1661">
                  <strong className="text-deep-blue" data-id="element-1662">Ad Spend:</strong> The
                  amount invested by the Client for advertising campaigns, paid
                  to a third-party.
                </p>

                <p className="leading-relaxed" data-id="element-1663">
                  <strong className="text-deep-blue" data-id="element-1664">Campaign:</strong> A set of
                  1–10 marketing ads used within a geographic region.
                </p>

                <p className="leading-relaxed" data-id="element-1665">
                  <strong className="text-deep-blue" data-id="element-1666">Campaign Launch:</strong>{' '}
                  The first business day following the date when the applicant
                  tracking system is live (system of record for Client to track
                  Recruits) and targeted ad campaigns are posted.
                </p>

                <p className="leading-relaxed" data-id="element-1667">
                  <strong className="text-deep-blue" data-id="element-1668">
                    Corporate Recruiter:
                  </strong>{' '}
                  The HIRE-provided recruiter assigned to manage and support a
                  Client's active campaigns. Also referred to as "Recruiter" in
                  prior Service Orders.
                </p>

                <p className="leading-relaxed" data-id="element-1669">
                  <strong className="text-deep-blue" data-id="element-1670">Placement:</strong> A
                  Recruit who has successfully completed and graduated from
                  HIRE's two-day sales school, or, if the Client has opted out
                  of HIRE's sales school, a Recruit who has begun the Client's
                  training program or entered the field.
                </p>

                <p className="leading-relaxed" data-id="element-1671">
                  <strong className="text-deep-blue" data-id="element-1672">Placement Date:</strong>{' '}
                  The date on which the Recruit successfully completes and
                  graduates from HIRE's two-day sales school, or, if the Client
                  has opted out of HIRE's sales school, the first day the
                  Recruit begins the Client's training program or enters the
                  field, whichever occurs first. This date triggers the
                  Placement Fee.
                </p>

                <p className="leading-relaxed" data-id="element-1673">
                  <strong className="text-deep-blue" data-id="element-1674">
                    Proprietary Recruiting System:
                  </strong>{' '}
                  HIRE's exclusive methods, processes, training materials, and
                  technology used by HIRE.
                </p>

                <p className="leading-relaxed" data-id="element-1675">
                  <strong className="text-deep-blue" data-id="element-1676">Recruit:</strong> A
                  candidate who is sourced by HIRE Campaigns.
                </p>

                <p className="leading-relaxed" data-id="element-1677">
                  <strong className="text-deep-blue" data-id="element-1678">
                    Sales School Start Date:
                  </strong>{' '}
                  The Monday on which the Recruit begins attendance at HIRE's
                  two-day sales school. If the Client has opted out of HIRE's
                  sales school, the Sales School Start Date shall be deemed the
                  first day the Recruit begins the Client's training program or
                  enters the field, whichever occurs first. This date serves as
                  the anchor for calculating the Retention Fee commencement
                  date.
                </p>

                <p className="leading-relaxed" data-id="element-1679">
                  <strong className="text-deep-blue" data-id="element-1680">Services:</strong> Services
                  listed in section 3.
                </p>

                <p className="leading-relaxed" data-id="element-1681">
                  <strong className="text-deep-blue" data-id="element-1682">Services Order:</strong>{' '}
                  The document by which Client orders, and HIRE agrees to
                  provide, Services Pursuant to this Agreement.
                </p>
              </div>
            </div>

            {/* 3. Scope of Services */}
            <div className="mb-12" data-id="element-1683">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1684">
                3. Scope of Services
              </h2>
              <p className="leading-relaxed mb-6" data-id="element-1685">
                As part of this Agreement, HIRE shall provide the following
                services, aligned to the fee categories in Section 4:
              </p>

              <div className="space-y-6" data-id="element-1686">
                <div data-id="element-1687">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1688">
                    Build
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1689">
                    <li data-id="element-1690">Custom Recruiting System Buildout</li>
                    <li data-id="element-1691">ATS Integration & Tracking</li>
                    <li data-id="element-1692">Initial Setup of Automated Applicant Communication</li>
                    <li data-id="element-1693">
                      Initial Configuration of Live Data & Dashboard Access
                    </li>
                  </ul>
                </div>

                <div data-id="element-1694">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1695">
                    Platform
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1696">
                    <li data-id="element-1697">
                      Access to HIRE's proprietary recruiting platform,
                      integrations, dashboards, and reporting tools
                    </li>
                    <li data-id="element-1698">Ongoing Ad Performance Analysis & Adjustments</li>
                    <li data-id="element-1699">Monthly Executive Recruiting Review</li>
                    <li data-id="element-1700">
                      Ongoing Recruiting Best Practice Training (including
                      webinars)
                    </li>
                    <li data-id="element-1701">
                      Hiring Manager Support (1:1 training, auditing, coaching)
                    </li>
                    <li data-id="element-1702">Performance Benchmarking</li>
                  </ul>
                </div>

                <div data-id="element-1703">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1704">
                    Campaign
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1705">
                    <li data-id="element-1706">
                      Targeted Ad Campaigns (copywriting, branding, posting job
                      listings)
                    </li>
                    <li data-id="element-1707">Pre-Screening & Pre-Qualification</li>
                    <li data-id="element-1708">Done-for-You Screening Calls</li>
                    <li data-id="element-1709">
                      Pre-Qualified Interviews Booked into Client's Calendar
                    </li>
                  </ul>
                </div>

                <div data-id="element-1710">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1711">
                    Corporate Recruiter
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-1712">
                    When the Corporate Recruiter service is selected, HIRE
                    replaces the Client's in-house recruiter function. Under
                    this service:
                  </p>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1713">
                    <li data-id="element-1714">
                      HIRE provides a corporate recruiter aligned with the
                      Client's campaigns.
                    </li>
                    <li data-id="element-1715">
                      The Client no longer conducts hiring meetings with a
                      hiring manager or recruiter.
                    </li>
                    <li data-id="element-1716">
                      Instead, the Client accepts or rejects candidates provided
                      by HIRE prior to the candidate attending Sales School or,
                      if the Client has opted out of HIRE's sales school, prior
                      to the candidate beginning the Client's training program
                      or entering the field.
                    </li>
                  </ul>
                </div>

                <div data-id="element-1717">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1718">
                    Placement
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1719">
                    <li data-id="element-1720">Candidate Experience Optimization</li>
                    <li data-id="element-1721">Onboarding System Buildout</li>
                    <li data-id="element-1722">Early Retention Strategy Development</li>
                    <li data-id="element-1723">
                      Virtual Sales Schools and related training/consulting to
                      support candidate readiness and retention
                    </li>
                  </ul>
                  <p className="leading-relaxed mt-3" data-id="element-1724">
                    Participation in HIRE's virtual sales school is optional.
                    Clients who opt out remain subject to all Placement and
                    Retention Fee obligations as defined in Section 4.1.
                  </p>
                </div>
              </div>

              <div className="mt-6 bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-1725">
                <p className="leading-relaxed" data-id="element-1726">
                  <strong className="text-deep-blue" data-id="element-1727">
                    General Terms of Service Delivery:
                  </strong>{' '}
                  Services are delivered in a commercially reasonable manner and
                  may be adjusted by HIRE to reflect evolving best practices.
                  Certain services, such as virtual sales schools, may be
                  subject to schedule availability.
                </p>
              </div>
            </div>

            {/* 4. Payment Terms */}
            <div className="mb-12" data-id="element-1728">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1729">
                4. Payment Terms
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1730">
                4.1 Product Fees
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1731">
                Client agrees to pay the following Product Fees in accordance
                with the amounts and rates set forth in the applicable Services
                Order:
              </p>
              <div className="space-y-4 mb-6" data-id="element-1732">
                <p className="leading-relaxed" data-id="element-1733">
                  <strong className="text-deep-blue" data-id="element-1734">Build (One-Time):</strong>{' '}
                  A one-time setup fee, invoiced and due upon execution of the
                  Services Order.
                </p>

                <p className="leading-relaxed" data-id="element-1735">
                  <strong className="text-deep-blue" data-id="element-1736">
                    Platform (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee that provides ongoing access to HIRE's
                  proprietary recruiting platform, integrations, dashboards,
                  reporting tools, and related support services.
                </p>

                <p className="leading-relaxed" data-id="element-1737">
                  <strong className="text-deep-blue" data-id="element-1738">
                    Corporate Recruiter (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee per Corporate Recruiter provided by
                  HIRE. Corporate Recruiter quantity must equal the number of
                  active campaigns under management.
                </p>

                <p className="leading-relaxed" data-id="element-1739">
                  <strong className="text-deep-blue" data-id="element-1740">
                    Campaign(s) (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee per campaign under management.
                </p>

                <div data-id="element-1741">
                  <p className="leading-relaxed mb-3" data-id="element-1742">
                    <strong className="text-deep-blue" data-id="element-1743">
                      Placement (Monthly, Billed in Arrears):
                    </strong>{' '}
                    The Placement fee structure consists of two components, both
                    invoiced at the start of each calendar month in arrears for
                    the prior calendar month:
                  </p>
                  <div className="ml-6 space-y-3" data-id="element-1744">
                    <p className="leading-relaxed" data-id="element-1745">
                      <strong data-id="element-1746">(a) Placement Fee:</strong> A monthly fee charged
                      per Recruit who has reached the Placement Date, as defined
                      in Section 2, during the prior calendar month.
                    </p>
                    <p className="leading-relaxed" data-id="element-1747">
                      <strong data-id="element-1748">(b) Retention Fee:</strong> A recurring monthly
                      fee charged per hire, commencing on the one-month
                      anniversary of the Sales School Start Date and continuing
                      for up to twelve (12) months, unless a different maximum
                      is specified in the applicable Services Order. Invoices
                      will itemize this component as "Retention Fee."
                    </p>
                  </div>
                  <p className="leading-relaxed mt-3" data-id="element-1749">
                    Both components survive termination of this Agreement and
                    remain payable for all Placements delivered prior to
                    termination.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1750">
                4.2 Payment Schedule
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1751">
                All payments are due upon receipt, unless otherwise specified in
                the applicable Services Order.
              </p>

              <div className="space-y-4 mb-6" data-id="element-1752">
                <p className="leading-relaxed" data-id="element-1753">
                  <strong className="text-deep-blue" data-id="element-1754">Build Fee:</strong> The
                  one-time Build Fee is due upon execution of this Agreement and
                  before HIRE begins the campaign and account build.
                </p>

                <p className="leading-relaxed" data-id="element-1755">
                  <strong className="text-deep-blue" data-id="element-1756">
                    Subscription Invoice (Platform, Campaign, and Corporate
                    Recruiter Fees):
                  </strong>{' '}
                  The first Platform Fee, Campaign Fee(s), and Corporate
                  Recruiter Fee(s) are due upon Campaign Launch. Thereafter,
                  these fees are invoiced together on each monthly anniversary
                  of Campaign Launch and are due upon receipt.
                </p>

                <p className="leading-relaxed" data-id="element-1757">
                  <strong className="text-deep-blue" data-id="element-1758">
                    Placement & Retention Fee Invoice:
                  </strong>{' '}
                  Placement Fees and Retention Fees are invoiced together at the
                  start of each calendar month, in arrears for the prior
                  calendar month, in accordance with Section 4.1, and are due
                  upon receipt.
                </p>
              </div>

              <p className="leading-relaxed mb-6" data-id="element-1759">
                <strong className="text-deep-blue" data-id="element-1760">
                  Late Payment Penalties:
                </strong>{' '}
                A five-day grace period applies. After five days, unpaid amounts
                will incur a 5% monthly interest fee. Client agrees HIRE may
                suspend all services and withhold all deliverables immediately
                upon nonpayment, without liability, until account is current.
              </p>

              <p className="leading-relaxed mb-6" data-id="element-1761">
                Client hereby authorizes HIRE to automatically process all
                payments via ACH transfer or credit card on file. Payments made
                by credit card shall be subject to a processing surcharge of
                three percent (3%).
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1762">
                4.3 Campaign Scope & Expansion
              </h3>
              <div className="space-y-4 mb-6" data-id="element-1763">
                <p className="leading-relaxed" data-id="element-1764">
                  <strong className="text-deep-blue" data-id="element-1765">
                    Number of Contracted Campaigns:
                  </strong>{' '}
                  The Client and HIRE agree that this Agreement covers _____
                  campaign(s), with each campaign defined as up to ten (10)
                  managed ads in a particular geographic region.
                </p>

                <p className="leading-relaxed" data-id="element-1766">
                  <strong className="text-deep-blue" data-id="element-1767">
                    Additional Campaign Expansion:
                  </strong>{' '}
                  The Client may expand by adding campaigns beyond the initially
                  agreed number. Each additional campaign will be billed at the
                  rate on the service order, contingent on HIRE's capacity and
                  mutual agreement.
                </p>

                <p className="leading-relaxed" data-id="element-1768">
                  <strong className="text-deep-blue" data-id="element-1769">
                    Campaign Reduction:
                  </strong>{' '}
                  Campaigns may be reduced or paused on a monthly basis with
                  written notice, provided that each campaign operates on a
                  minimum thirty (30)-day cycle. Any reduction shall be prorated
                  and aligned with the Client's monthly billing cycle.
                </p>

                <div data-id="element-1770">
                  <p className="leading-relaxed" data-id="element-1771">
                    <strong className="text-deep-blue" data-id="element-1772">
                      Campaign Reallocations & Adjustments:
                    </strong>
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2" data-id="element-1773">
                    <li data-id="element-1774">
                      Ad spend may be reallocated across campaigns in real time,
                      based on performance and hiring needs.
                    </li>
                    <li data-id="element-1775">
                      If a campaign is removed and replaced with an entirely new
                      campaign, the Client must confirm with HIRE prior to
                      implementation.
                    </li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1776">
                4.4 Ad Spend Responsibility
              </h3>
              <p className="leading-relaxed" data-id="element-1777">
                The Client is solely responsible for all advertising costs ("Ad
                Spend") incurred in connection with campaigns under this
                Agreement. Ad Spend is billed directly by the applicable job
                boards or advertising platforms to the Client and is not
                included in HIRE's fees.
              </p>
            </div>

            {/* 5. Performance Commitment */}
            <div className="mb-12" data-id="element-1778">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1779">
                5. Performance Commitment
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-1780">
                If, within the first 90 days of Campaign Launch AND the Client
                spends at least $12,500 in total advertising, HIRE guarantees at
                least twenty-five (25) Recruits who have been offered a position
                by or for the Client.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-1781">
                If this condition is not met within 90 days, HIRE will continue
                providing campaign services at no additional Platform or
                Campaign Fee until the guarantee is fulfilled. The Client
                remains responsible for advertising costs and all Placement and
                Retention Fees for all Placements delivered during this period.
              </p>
              <p className="leading-relaxed" data-id="element-1782">
                This guarantee is contingent upon the Client's full adherence to
                HIRE's Proprietary Recruiting System as directed, including:
                attending all scheduled interviewing and coaching calls with
                HIRE; following HIRE's interview and onboarding process;
                responding to candidate submissions within one (1) business day;
                maintaining an active Zoom account and attending all HIRE
                coaching and interviewing calls via Zoom; maintaining sufficient
                calendar availability to schedule and conduct candidate
                interviews in a timely manner; and fulfilling all Client
                responsibilities under Section 6 of this Agreement. Failure to
                meet any of the above conditions voids this performance
                guarantee. This guarantee applies only while the Client's
                account is in good standing, meaning all Subscription Fees are
                current and paid in full throughout the 90-day guarantee period.
              </p>
            </div>

            {/* 6. Client Responsibilities */}
            <div className="mb-12" data-id="element-1783">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1784">
                6. Client Responsibilities
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-1785">The Client shall:</p>
              <ul className="list-disc ml-6 space-y-2" data-id="element-1786">
                <li data-id="element-1787">
                  Have personnel to support interviews, hiring, and onboarding.
                </li>
                <li data-id="element-1788">
                  Allocate proper time for onboarding activities and ongoing
                  meetings.
                </li>
                <li data-id="element-1789">
                  Provide branding materials (logo, tagline, color scheme).
                </li>
                <li data-id="element-1790">Collaborate with HIRE on culture video production.</li>
                <li data-id="element-1791">Set up a dedicated company email for Indeed access.</li>
                <li data-id="element-1792">
                  Provide Google Calendar details for recruiters/screeners.
                </li>
                <li data-id="element-1793">Report sales statistics weekly for Recruits.</li>
                <li data-id="element-1794">
                  Provide necessary materials within seven (7) days of contract
                  execution.
                </li>
                <li data-id="element-1795">
                  Notify HIRE within one (1) business day of a Recruit beginning
                  the Client's training program or entering the field, in the
                  event the Client has opted out of HIRE's two-day sales school.
                  This notification serves as the basis for determining the
                  Placement Date and Sales School Start Date under this
                  Agreement.
                </li>
              </ul>
            </div>

            {/* 7. Confidentiality & Proprietary Rights */}
            <div className="mb-12" data-id="element-1796">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1797">
                7. Confidentiality & Proprietary Rights
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1798">
                7.1 Confidentiality
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1799">
                The Client agrees all aspects of HIRE's Proprietary Recruiting
                System are confidential and shall not be disclosed, copied, or
                reverse-engineered.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1800">
                7.2 Data Use
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1801">
                Applicant data is for the Client's internal use only. HIRE
                reserves the right to use campaign data (including
                non-anonymized data where appropriate) for case studies,
                marketing, and analysis, provided Client business interests are
                not compromised.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1802">
                HIRE may reference Client's name and logo in general marketing
                materials unless Client objects in writing.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1803">
                7.3 Non-Compete & Non-Circumvention
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1804">
                The Client shall not, directly or indirectly:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-1805">
                <li data-id="element-1806">
                  Replicate, use, or modify HIRE's recruiting system,
                  advertisements, or proprietary materials outside of this
                  Agreement;
                </li>
                <li data-id="element-1807">
                  Transfer, disclose, or make available HIRE's recruiting
                  system, advertisements, or proprietary materials to any third
                  party, including competitors, agencies, or contractors; or
                </li>
                <li data-id="element-1808">
                  Engage in any conduct that has the purpose or effect of
                  circumventing HIRE's role in providing recruiting services.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-1809">
                This restriction applies for a period of two (2) years, or for
                the full duration that Placement Fees remain payable under
                Section 4.1, whichever is longer, after termination of this
                Agreement.
              </p>
              <p className="leading-relaxed" data-id="element-1810">
                Violations entitle HIRE to seek injunctive relief and liquidated
                damages equal to twelve (12) months of lost value.
              </p>
            </div>

            {/* 8. Term, Renewal, and Termination */}
            <div className="mb-12" data-id="element-1811">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1812">
                8. Term, Renewal, and Termination
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1813">
                8.1 Term
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1814">
                This Agreement shall remain in effect for an initial term of 30
                (30) days, beginning on the date of Campaign Launch.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1815">
                8.2 Renewal
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1816">
                After the initial term, the Agreement renews month-to-month
                unless either party provides at least fourteen (14) days'
                written notice of non-renewal.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1817">
                8.3 Early Termination for Convenience (28-Day Guarantee)
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1818">
                Notwithstanding any other provision of this Agreement, the
                Client may terminate for convenience at any time within the
                first twenty-eight (28) days following Campaign Launch. In such
                event:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-1819">
                <li data-id="element-1820">
                  HIRE shall refund one hundred percent (100%) of the Build Fee
                </li>
                <li data-id="element-1821">No Placement Fees shall be due.</li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-1822">
                Upon such termination, both parties are released from all
                further obligations.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-1823">
                Notwithstanding the foregoing, Client's right to terminate for
                convenience is conditioned upon all undisputed Subscription Fees
                being paid in full and current as of the date notice of
                termination is given.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-1824">
                For the avoidance of doubt, the Client's right to terminate for
                convenience and receive a Build Fee refund is further
                conditioned upon the Client having paid the first thirty (30)
                days of Subscription Fees in full following Campaign Launch. If
                the Client terminates prior to Campaign Launch, the Build Fee is
                non-refundable and the twenty-eight (28) day termination for
                convenience window shall not commence until Campaign Launch.
              </p>
              <p className="leading-relaxed" data-id="element-1825">
                If Client submits a notice of termination while any Subscription
                Fees for the then-current billing period remain unpaid, Client
                will remain responsible for those unpaid Subscription Fees, and
                Client will not be entitled to any refund, credit, or proration
                in connection with such termination.
              </p>
            </div>

            {/* 9. Dispute Resolution & Governing Law */}
            <div className="mb-12" data-id="element-1826">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1827">
                9. Dispute Resolution & Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-1828">
                This Agreement shall be governed by Arizona law. Disputes shall
                first be resolved through mediation.
              </p>
            </div>

            {/* 10. Indemnification & Limitation of Liability */}
            <div className="mb-12" data-id="element-1829">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1830">
                10. Indemnification & Limitation of Liability
              </h2>

              <p className="leading-relaxed mb-6" data-id="element-1831">
                <strong className="text-deep-blue" data-id="element-1832">
                  Indemnification by Client:
                </strong>{' '}
                Client indemnifies HIRE against claims arising from misuse of
                the system, hiring decisions, or breach.
              </p>

              <p className="leading-relaxed mb-6" data-id="element-1833">
                <strong className="text-deep-blue" data-id="element-1834">
                  Indemnification by HIRE:
                </strong>{' '}
                HIRE indemnifies Client against claims resulting from gross
                negligence or intentional misconduct.
              </p>

              <p className="leading-relaxed" data-id="element-1835">
                <strong className="text-deep-blue" data-id="element-1836">
                  Limitation of Liability:
                </strong>{' '}
                HIRE's liability shall not exceed the total fees paid by Client
                in the three months preceding a claim. HIRE shall not be liable
                for indirect or consequential damages.
              </p>
            </div>

            {/* 11. Amendments & Notices */}
            <div className="mb-12" data-id="element-1837">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1838">
                11. Amendments & Notices
              </h2>
              <p className="leading-relaxed" data-id="element-1839">
                All amendments must be in writing and signed by both parties.
                Notices must be in writing. "Recruiter" and "Corporate
                Recruiter" shall be used interchangeably throughout this
                Agreement and any Services Order executed hereunder. Any
                reference to "Recruiter" in a Services Order shall be deemed to
                refer to the Corporate Recruiter service as defined in Section
                2. For purposes of any Services Order executed prior to the
                current version of this Agreement, "Qualified HIRE" and "Active
                HIRE" shall have the same meaning as "Placement" as defined in
                Section 2, and "Recurring Placement Fees" shall have the same
                meaning as "Placement Fees and Retention Fees" as defined in
                Section 4.1.
              </p>
            </div>

            {/* 12. Acknowledgment */}
            <div className="mb-12" data-id="element-1840">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1841">
                12. Acknowledgment and Acceptance
              </h2>
              <p className="leading-relaxed" data-id="element-1842">
                By signing below, both parties acknowledge they have read,
                understood, and agreed to the terms of this Agreement.
              </p>
            </div>

            {/* EXHIBIT A */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-1843">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1844">
                EXHIBIT A – TERMINATION & EXIT PROVISIONS
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1845">
                Termination Conditions:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-1846">
                <li data-id="element-1847">
                  This Agreement shall renew on a month-to-month basis after the
                  initial thirty (30) day term, unless either party provides
                  fourteen (14) days' written notice of non-renewal.
                </li>
                <li data-id="element-1848">
                  The Client may terminate for convenience within the first
                  twenty eight (28) days of execution pursuant to Section 8.3 of
                  this Agreement.
                </li>
                <li data-id="element-1849">
                  HIRE reserves the right to terminate immediately if the Client
                  fails to make payments or breaches confidentiality
                  obligations.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1850">
                Financial Obligations Upon Termination:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-1851">
                <li data-id="element-1852">
                  The Client remains responsible for all outstanding invoices up
                  to the termination date.
                </li>
                <li data-id="element-1853">
                  Placement Fees and Retention Fees remain payable for all
                  Placements, up to twelve (12) months from the Placement Date.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1854">
                Survival of Obligations:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1855">
                Confidentiality, proprietary rights, and all payment obligations
                (including Placement Fees) shall survive termination.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1856">
                Post-Termination Use of Intellectual Property & Data:
              </h3>
              <ul className="list-disc ml-6 space-y-2" data-id="element-1857">
                <li data-id="element-1858">
                  The Client shall cease use of any proprietary materials,
                  recruiting systems, training programs, or strategies developed
                  by HIRE.
                </li>
                <li data-id="element-1859">
                  Any materials provided by HIRE (including advertisements,
                  branding, or process structures) shall not be used to
                  replicate services independently or with a third-party vendor.
                </li>
                <li data-id="element-1860">
                  HIRE retains ownership of all data, processes, and
                  confidential information provided during the term.
                </li>
              </ul>
            </div>

            {/* EXHIBIT B */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-1861">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1862">
                EXHIBIT B – INDEMNIFICATION & LIMITATION OF LIABILITY
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1863">
                Indemnification by the Client:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1864">
                The Client agrees to indemnify, defend, and hold harmless HIRE
                from any claims, damages, or liabilities arising from the
                Client's misuse of the system, hiring decisions, or breach of
                contract.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1865">
                The Client assumes full responsibility for compliance with
                employment laws and regulations.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1866">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1867">
                HIRE shall indemnify the Client against claims resulting from
                gross negligence or intentional misconduct in delivering
                services under this Agreement.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1868">
                HIRE is not responsible for hiring outcomes, employee
                performance, misconduct, retention results, or legal disputes
                related to employment practices.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1869">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1870">
                In no event shall HIRE's total liability exceed the total fees
                paid by the Client in the three (3) months preceding the claim.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1871">
                HIRE shall not be liable for indirect, incidental, or
                consequential damages, including loss of profits, business
                interruptions, or reputational harm.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1872">
                Nothing in this section shall limit the Client's obligation to
                pay Placement Fees or other amounts due under this Agreement.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1873">
                Force Majeure:
              </h3>
              <p className="leading-relaxed" data-id="element-1874">
                Neither party shall be held liable for delays or failures in
                performance due to causes beyond their reasonable control,
                including but not limited to natural disasters, labor strikes,
                government actions, or technological failures. Payment
                obligations incurred prior to the force majeure event shall
                remain enforceable and are not excused.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="section-padding bg-gray-50" data-id="element-1875">
        <div className="container-custom" data-id="element-1876">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1877">
            <h2 className="mb-6" data-id="element-1878">Questions About This Agreement?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-1879">
              We're happy to discuss any questions or concerns you have about
              our service agreement.
            </p>
            <a href="/book-call" className="inline-block bg-mint hover:bg-mint-dark text-deep-blue font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1880">
              Schedule a Call →
            </a>
          </div>
        </div>
      </section>
    </div>;
}